module.exports = __webpack_public_path__ + "static/media/mirror_munich.c3f74dad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/mirror_munich.jpg
// module id = 462
// module chunks = 0